export enum APINames {
  SPIN_BUTTON = "spinbutton",
  SOUND_BUTTON = "soundbutton",
  BET_BUTTON = "betbutton",
  AUTOPLAY_BUTTON = "autoplaybutton",
  MENU_BUTTON = "menubutton",
  MENU_NAV_BUTTON = "menunavbutton",
  QUICKSPIN_BUTTON = "quickspinbutton",
  BET_SETTING_BUTTON = "betsettingbutton",
  AUTOPLAY_STOP_BUTTON = "autoplaystopbutton",
  AUTOPLAY_SETTING_BUTTON = "autoplaysettingbutton",
  AUTOPLAY_ADVANCED_SETTING_BUTTON = "autoplayadvancedsettingbutton",
  AUTOPLAY_START_BUTTON = "autoplaystartbutton",
  AUTOPLAY_CLOSE_BUTTON = "autoplayclosebutton",
  DIALOG_BUTTON = "dialogButton",
  GAME_RULES_BUTTON = "gamerulesbutton"
}
